module.exports = __webpack_public_path__ + "img/adminServiceInfo1.24901ea5.png";